<template>
    <div @click="clickHandler">
        <slot>
            <button class="button-third-party btn btn-block" :data-tpa-type="tpaType">
                <div v-if="loading" class="loading">
                    <div class="loadingLeft"><div></div></div>
                    <div class="loadingRight"><div></div></div>
                </div>
                <div class="icon-wrapper">
                    <svgIcon icon-holder-class="icon-third-party" icon-id="icon-facebook" />
                </div>
                <span class="social-text">Continue with Facebook</span>
            </button>
        </slot>
    </div>
</template>

<script>
import queryString from 'query-string';
import svgIcon from '@arena/toolkit/src/components/common/icon-svg';

export default {
    name: 'ButtonFacebook',
    components: {
        svgIcon,
    },
    props: {
        tpaType: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        oauthState: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            client_id: '395670150835943',
            scope: 'email',
            not_support_fb_sdk: false,
            redirect_uri: `${window.location.origin}/account/login/cb/facebook`,
        };
    },
    computed: {
        isApplication() {
            return this.$store.state.isApplication;
        },
        // client sdk loading, only web
        loading() {
            return !this.$store.state.login.tpa.tpaInit.facebook && !this.isApplication;
        },
    },
    mounted() {
        if (this.loading) {
            this.loadSDK();
            // timeout for sdk loading
            setTimeout(() => {
                if (this.loading) {
                    this.not_support_fb_sdk = true;
                    this.$store.commit('login/tpa/setTpaInit', { facebook: true });
                }
            }, 3000);
        }
    },
    methods: {
        loadSDK() {
            window.fbAsyncInit = () => {
                FB.init({
                    appId: this.client_id,
                    cookie: true, // enable cookies to allow the server to access the session
                    xfbml: true, // parse social plugins on this page
                    version: 'v4.0', // https://developers.facebook.com/docs/graph-api/changelog/
                });
                this.$store.commit('login/tpa/setTpaInit', { facebook: true });
            };
            const locale = this.$i18n.locale || 'en',
                fbLocale = `${locale}_${locale.toUpperCase()}`.replace('en_EN', 'en_US').replace('zh_ZH', 'zh_TW');
            this.$root.addScript('facebook-jssdk', `https://connect.facebook.net/${fbLocale}/sdk.js`).catch(() => {
                // it can be failed by blocking js load due to firefox Tracking Protection
                this.not_support_fb_sdk = true;
                this.$store.commit('login/tpa/setTpaInit', { facebook: true });
            });
        },
        clickHandler() {
            if (this.disabled || this.loading) return;

            this.$emit('click', 'Facebook');

            // manual login
            if (this.isApplication || this.not_support_fb_sdk) {
                const params = new URLSearchParams();
                params.set('client_id', this.client_id);
                params.set('redirect_uri', this.redirect_uri);
                params.set('response_type', 'token');
                params.set('scope', this.scope);
                params.set('display', 'popup');
                const clientCode = this.$uuid.v4();
                const return_url = this.$route.query.return_url;
                const state = {
                    ...(this.oauthState || {}),
                    ...(return_url ? { return_url } : {}),
                    ...(this.$route.query.unified ? { unified: 'unified' } : {}),
                };
                // clientCode in state is only for launcher
                if (this.$store.state.isApplication) {
                    state.clientCode = clientCode;
                }
                params.set('state', encodeURIComponent(queryString.stringify(state)));
                const url = `https://www.facebook.com/v4.0/dialog/oauth?${params.toString()}`;

                if (this.$store.state.isApplication) {
                    this.$router.push({
                        name: 'login-tpa-callback-app',
                        params: { clientCode, socialProvider: 'Facebook', url },
                    });
                } else {
                    // normal browser redirect mode
                    window.location = url;
                }
            } else {
                FB.login(
                    (res) => {
                        this.tpaLogin(res.authResponse);
                    },
                    { scope: 'email' }
                );
            }
        },
        tpaLogin(auth) {
            if (!auth || !auth.accessToken) return;
            const params = new URLSearchParams(),
                isUnified = this.$route.query.unified,
                state = {
                    ...(this.oauthState || {}),
                    ...(isUnified ? { unified: 'unified' } : {}),
                };
            params.set('access_token', auth.accessToken);
            if (this.oauthState || isUnified) {
                params.set('state', queryString.stringify(state));
            }
            this.$router.push({
                name: 'login-tpa-callback',
                params: { socialProvider: 'facebook' },
                query: this.$route.query,
                hash: `#${params.toString()}`,
            });
        },
    },
};
</script>

<style lang="less" scoped>
button {
    background-color: #3b579d;
    &:hover {
        background-color: #4768b1;
    }
    &:focus {
        background-color: #2f4689;
    }
}
.button-third-party {
    margin: 0 0 10px;
    padding: 14px 0px;
    position: relative;
    .icon-wrapper {
        display: inline-flex;
        padding-right: 16px;
        vertical-align: middle;
        margin-top: -1px;
        .icon-third-party {
            width: 22px;
            height: 22px;
        }
    }
    .social-text {
        color: #ffffff;
        font-size: 15px;
        vertical-align: middle;
    }
}
</style>
